/* You can add your custom scripts here */

class BCPOSelectField {
  constructor(selectField) {
    this.selectField = selectField;
    this.options = this.selectField.querySelectorAll('option');

    this.updateOptionLabels();

    this.selectField.addEventListener('change', this.handleSelectChange.bind(this));
  }

  // Get the data-price attribute from each option node and update the label, if it exists
  updateOptionLabels() {
    this.options.forEach(option => {
      const price = option.getAttribute('data-price');
      const text = option.textContent;

      if (price && price != '0') {
        option.textContent = `${text} - ${this.getFormattedPrice(price)}`;
      }
    });
  }

  handleSelectChange(e) {
    // Get the price from the selected option, if it exists, and 
    const selectedOption = this.options[this.selectField.selectedIndex];

    if (!selectedOption) {
      return;
    }

    const price = selectedOption.getAttribute('data-price');
    const name = window.slugify((this.selectField.name ?? '').replace(/properties\[/, '').replace(/\]/, ''));

    if (price) {
      // Update the price on the page
      this.updateWindowPriceModifications(price, name);

      this.updatePdpPrice();
    }
  }

  updateWindowPriceModifications(price, handle) {
    window.pdpPriceModifications[handle] = parseInt(price);
  }

  updatePdpPrice() {
    window.dispatchEvent(new CustomEvent('pdpPriceUpdate'));
  }

  getFormattedPrice(number) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number).replace('.00', '');
  }
}

class Price {
  constructor() {
    this.price = document.querySelector('[data-price]');
    this.originalPrice = this.price.textContent;
    this.priceModifiers = window.pdpPriceModifications;

    window.addEventListener('pdpPriceUpdate', this.updatePrice.bind(this));
  }

  updatePrice() {
    const newPrice = this.calculateNewPrice();
    this.price.textContent = newPrice.replace('.00', '');
  }

  calculateNewPrice() {
    let newPrice = parseFloat(this.originalPrice.replace(/[^0-9.-]+/g, ''));

    for (let key in this.priceModifiers) {
      newPrice += this.priceModifiers[key];
    }

    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(newPrice);
  }
}

window.addEventListener('load', function () {
  if (!document.querySelector('.bcpo')) {
    return;
  }

  // [field name]: price (int)
  window.pdpPriceModifications = {};

  new Price();

  const selects = document.querySelectorAll('.bcpo select');

  selects.forEach(select => {
    new BCPOSelectField(select);
  });
});
